// extracted by mini-css-extract-plugin
module.exports = {"user_archive_section":"UserArchiveSection_user_archive_section__1SFEG","back_btn":"UserArchiveSection_back_btn__1Ul56","back_btn_icon":"UserArchiveSection_back_btn_icon__ZA33c"};